import { render, staticRenderFns } from "./BasePercentBar.vue?vue&type=template&id=641758d2&scoped=true&"
import script from "./BasePercentBar.vue?vue&type=script&lang=js&"
export * from "./BasePercentBar.vue?vue&type=script&lang=js&"
import style0 from "./BasePercentBar.vue?vue&type=style&index=0&id=641758d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641758d2",
  null
  
)

export default component.exports